module.exports = __webpack_public_path__ + "static/media/02-flag.a643f6f1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructiongifs/02-flag.gif
// module id = 259
// module chunks = 0